// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-wrapper {
  height: var(--boxx-content-divider-height, 4px);
  margin-top: var(--boxx-content-divider-margin-top, 22px);
  margin-bottom: var(--boxx-content-divider-margin-bottom, 22px);
  margin-left: var(--boxx-content-divider-margin-left, 16px);
  margin-right: var(--boxx-content-divider-margin-right, 16px);
  padding: var(--boxx-content-divider-padding, 0);
  line-height: var(--boxx-content-line-height, 0);
}
.icon-wrapper ion-icon {
  width: var(--boxx-icon-width, 100%);
  height: var(--boxx-icon-height, 4px);
}

:host([position=vertical]) > div {
  border: 1px solid white;
  transform: rotate(90deg);
  transform-origin: left;
  position: relative;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/content-divider/content-divider.component.scss"],"names":[],"mappings":"AAAA;EACI,+CAAA;EACA,wDAAA;EACA,8DAAA;EACA,0DAAA;EACA,4DAAA;EACA,+CAAA;EACA,+CAAA;AACJ;AAAI;EACI,mCAAA;EACA,oCAAA;AAER;;AAEA;EACI,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AACJ","sourcesContent":[".icon-wrapper {\n    height: var(--boxx-content-divider-height, 4px);\n    margin-top: var(--boxx-content-divider-margin-top, 22px);\n    margin-bottom: var(--boxx-content-divider-margin-bottom, 22px);\n    margin-left: var(--boxx-content-divider-margin-left, 16px);\n    margin-right: var(--boxx-content-divider-margin-right, 16px);\n    padding: var(--boxx-content-divider-padding, 0);\n    line-height: var(--boxx-content-line-height, 0);\n    ion-icon {\n        width: var(--boxx-icon-width, 100%);\n        height: var(--boxx-icon-height, 4px);\n    }\n}\n\n:host([position=\"vertical\"]) > div {\n    border: 1px solid white;\n    transform: rotate(90deg);\n    transform-origin: left;\n    position: relative;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
